/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.25
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { LocalAccountTypesFromJSON, LocalAccountTypesToJSON, } from './';
export function UserCreateCommandFromJSON(json) {
    return UserCreateCommandFromJSONTyped(json, false);
}
export function UserCreateCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'subjectId': !exists(json, 'subjectId') ? undefined : json['subjectId'],
        'loginName': !exists(json, 'loginName') ? undefined : json['loginName'],
        'prehashedPassword': !exists(json, 'prehashedPassword') ? undefined : json['prehashedPassword'],
        'mustChangePasswordNextLogon': !exists(json, 'mustChangePasswordNextLogon') ? undefined : json['mustChangePasswordNextLogon'],
        'localAccountFlag': !exists(json, 'localAccountFlag') ? undefined : LocalAccountTypesFromJSON(json['localAccountFlag']),
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'userRole': !exists(json, 'userRole') ? undefined : json['userRole'],
        'contactId': !exists(json, 'contactId') ? undefined : json['contactId'],
        'workerVendor': !exists(json, 'workerVendor') ? undefined : json['workerVendor'],
    };
}
export function UserCreateCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'subjectId': value.subjectId,
        'loginName': value.loginName,
        'prehashedPassword': value.prehashedPassword,
        'mustChangePasswordNextLogon': value.mustChangePasswordNextLogon,
        'localAccountFlag': LocalAccountTypesToJSON(value.localAccountFlag),
        'propertyId': value.propertyId,
        'userRole': value.userRole,
        'contactId': value.contactId,
        'workerVendor': value.workerVendor,
    };
}
